import React from "react";

export default function PrintIcon({ color = "white" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <g clip-path="url(#clip0_795_5824)">
        <path
          d="M20.5832 8.66667H5.4165C3.61817 8.66667 2.1665 10.1183 2.1665 11.9167V16.25C2.1665 17.4417 3.1415 18.4167 4.33317 18.4167H6.49984V20.5833C6.49984 21.775 7.47484 22.75 8.6665 22.75H17.3332C18.5248 22.75 19.4998 21.775 19.4998 20.5833V18.4167H21.6665C22.8582 18.4167 23.8332 17.4417 23.8332 16.25V11.9167C23.8332 10.1183 22.3815 8.66667 20.5832 8.66667ZM16.2498 20.5833H9.74984C9.154 20.5833 8.6665 20.0958 8.6665 19.5V15.1667H17.3332V19.5C17.3332 20.0958 16.8457 20.5833 16.2498 20.5833ZM20.5832 13C19.9873 13 19.4998 12.5125 19.4998 11.9167C19.4998 11.3208 19.9873 10.8333 20.5832 10.8333C21.179 10.8333 21.6665 11.3208 21.6665 11.9167C21.6665 12.5125 21.179 13 20.5832 13ZM18.4165 3.25H7.58317C6.98734 3.25 6.49984 3.7375 6.49984 4.33333V6.5C6.49984 7.09583 6.98734 7.58333 7.58317 7.58333H18.4165C19.0123 7.58333 19.4998 7.09583 19.4998 6.5V4.33333C19.4998 3.7375 19.0123 3.25 18.4165 3.25Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_795_5824">
          <rect width="26" height="26" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
}
